import type { CommentContentObjectListDataObject, CommentTopParentType } from '../../service';
import {
  type CommunityContentObjectList,
  type ProgramContentObjectList,
  createCommunityContentObjectList,
  createProgramContentObjectList,
} from '../contentable-type-content-objects';

export type { CommentTopParentType } from '../../service';

export type CommentContentObject = CommentContentObjectList;

export type CommentContentObjectList = CommunityCommentContentObjectList | ProgramCommentContentObjectList;

export type CommunityCommentContentObjectList = {
  comment: { id: string };
  topParentId: string;
  topParentShareableId: string;
  topParentType: CommentTopParentType;
  type: 'comment';
} & CommunityContentObjectList;

export type ProgramCommentContentObjectList = {
  comment: { id: string };
  topParentId: string;
  topParentShareableId: string;
  topParentType: CommentTopParentType;
  type: 'comment';
} & ProgramContentObjectList;

export const createCommentContentObjectList = (data: CommentContentObjectListDataObject): CommentContentObjectList => {
  switch (data.contentable_type) {
    case 'Community':
      return {
        ...createCommunityContentObjectList(data),
        comment: data.comment,
        topParentId: data.top_parent_id,
        topParentShareableId: data.top_parent_shareable_id,
        topParentType: data.top_parent_type,
        type: 'comment',
      };
    case 'Program':
      return {
        ...createProgramContentObjectList(data),
        comment: data.comment,
        topParentId: data.top_parent_id,
        topParentShareableId: data.top_parent_shareable_id,
        topParentType: data.top_parent_type,
        type: 'comment',
      };
  }
};
